import dashboardApi from 'services/api/dashboard'

export const getAnalytics = (fromDate, toDate, forSubsidiaries) => {
  return async dispatch => {
    dispatch({
      type: 'GET_ANALYTICS_STARTED',
      payload: {
        fromDate,
        toDate
      }
    })

    try {
      const analyticsData = await dashboardApi.autoinviteSnapshot({
        fromDate,
        toDate,
        forSubsidiaries
      })

      analyticsData.dailyActivities.map(day => {
        day.clickRateGraph = Math.min(100, day.clickRate)
        return day
      })

      dispatch({
        type: 'GOT_ANALYTICS',
        payload: {
          analyticsData,
          updatedOn: Date.now(),
          fromDate,
          toDate
        }
      })
    } catch (err) {
      console.warn({ err })
      dispatch({
        type: 'GET_ANALYTICS_FAILED',
        payload: err
      })
    }
  }
}
